import React from 'react'

import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'

type Props = {
  verifierName: string
}

export function NoTasksVerifiedContent({ verifierName }: Props) {
  return (
    <>
      <H2 className="mb-3 mt-5 text-center">Verification in progress</H2>
      <P>
        We'll pass your information to {verifierName} to complete the verification. Contact {verifierName} if you have
        questions.
      </P>
    </>
  )
}
